export const STORY_OUTLINE_MIN_WORDS = 200
